import {Skeleton, cn} from "@project/design-system-web";

export function TableSkeleton({
  rows = 5,
  columns = 4,
  className,
}: {
  rows?: number;
  columns?: number;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-1 flex-col overflow-hidden rounded-lg border", className)}>
      {/* Header Row */}
      <div className="bg-surface-secondary flex border-b px-4 py-3">
        {Array.from({length: columns}).map((_, i) => (
          <div key={i} className="flex-1 px-2">
            <Skeleton className="h-4 w-2/3 rounded" />
          </div>
        ))}
      </div>

      {/* Data Rows */}
      <div className="flex-1 overflow-hidden">
        {Array.from({length: rows}).map((_, rowIndex) => (
          <div key={rowIndex} className="border-divider flex border-b px-4 py-4 last:border-0">
            {Array.from({length: columns}).map((_, colIndex) => (
              <div key={colIndex} className="flex-1 px-2">
                <Skeleton className="h-4 w-full rounded" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
